import {
  createTheme as createMuiTheme,
  ThemeOptions,
} from "@mui/material/styles";

import * as colors from "./colors";
import * as effects from "./effects";
import * as gradients from "./gradients";
import * as numbers from "./numbers";
import * as typography from "./typography";
import "./types";

type CustomThemeOptions = Omit<
  ThemeOptions,
  "effects" | "gradients" | "numbers"
>;

export const createTheme = (
  mode: "light" | "dark" | "friendly",
  options: CustomThemeOptions,
) => {
  const isLightMode = mode === "light";

  return createMuiTheme({
    effects: isLightMode ? effects.lightEffects : effects.darkEffects,
    gradients: gradients.gradients,
    numbers: numbers.numbers,
    palette: isLightMode ? colors.lightColorPalette : colors.darkColorPalette,
    typography: typography.typography,
    ...options,
  });
};

export { colors, numbers, typography };
